import { render, staticRenderFns } from "./rpterstdnotpaid.vue?vue&type=template&id=75ecbb06&"
import script from "./rpterstdnotpaid.vue?vue&type=script&lang=js&"
export * from "./rpterstdnotpaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports